// removed by extract-text-webpack-plugin
module.exports = {"trend":"trend___2Twv-","trendItem":"trendItem___2WRGm","content":"content___3H2cL","miniContent":"miniContent___3a8k4","title":"title___OoS3E","value":"value___2tQ0G","up":"up___2Tnsj","down":"down___3ytCu","trendgray":"trendgray___1GHCy","mini":"mini___QsIfg","xxl":"xxl___3ixVl","xl":"xl___kInEu","lg":"lg___GH_wv","xlg":"xlg___29JWM","md":"md___5pZTi","sm":"sm___36SzN","xs":"xs___3H5K1"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Trend/index.less
// module id = 436
// module chunks = 0